export default __webpack_public_path__ + "static/media/spacing-bottom.aadea844.svg";